// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/types/asset.proto" (package "mlmbox.types", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message mlmbox.types.Asset
 */
export interface Asset {
    /**
     * @generated from protobuf field: uint32 asset_id = 1;
     */
    assetId: number;
    /**
     * @generated from protobuf field: string asset_name = 2;
     */
    assetName: string;
    /**
     * @generated from protobuf field: string asset_title = 3;
     */
    assetTitle: string;
    /**
     * @generated from protobuf field: uint32 decimal = 4;
     */
    decimal: number;
}
/**
 * @generated from protobuf message mlmbox.types.Asset.Id
 */
export interface Asset_Id {
    /**
     * @generated from protobuf oneof: unique_field
     */
    uniqueField: {
        oneofKind: "assetId";
        /**
         * @generated from protobuf field: uint32 asset_id = 1;
         */
        assetId: number;
    } | {
        oneofKind: "assetName";
        /**
         * @generated from protobuf field: string asset_name = 2;
         */
        assetName: string;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message mlmbox.types.Asset.Amount
 */
export interface Asset_Amount {
    /**
     * @generated from protobuf field: uint32 asset_id = 1;
     */
    assetId: number;
    /**
     * @generated from protobuf field: string value = 2;
     */
    value: string;
}
/**
 * @generated from protobuf message mlmbox.types.Asset.MarketCap
 */
export interface Asset_MarketCap {
    /**
     * @generated from protobuf field: uint32 asset_id = 1;
     */
    assetId: number;
    /**
     * @generated from protobuf field: string asset_name = 2;
     */
    assetName: string;
    /**
     * @generated from protobuf field: string market_cap = 3;
     */
    marketCap: string;
    /**
     * @generated from protobuf field: uint32 modified_at = 4;
     */
    modifiedAt: number;
}
/**
 * @generated from protobuf message mlmbox.types.Asset.MarketCap.List
 */
export interface Asset_MarketCap_List {
    /**
     * @generated from protobuf field: repeated mlmbox.types.Asset.MarketCap items = 1;
     */
    items: Asset_MarketCap[];
}
/**
 * @generated from protobuf message mlmbox.types.AssetList
 */
export interface AssetList {
    /**
     * @generated from protobuf field: repeated mlmbox.types.Asset items = 1;
     */
    items: Asset[];
}
// @generated message type with reflection information, may provide speed optimized methods
class Asset$Type extends MessageType<Asset> {
    constructor() {
        super("mlmbox.types.Asset", [
            { no: 1, name: "asset_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "asset_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "asset_title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "decimal", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Asset>): Asset {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.assetId = 0;
        message.assetName = "";
        message.assetTitle = "";
        message.decimal = 0;
        if (value !== undefined)
            reflectionMergePartial<Asset>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Asset): Asset {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 asset_id */ 1:
                    message.assetId = reader.uint32();
                    break;
                case /* string asset_name */ 2:
                    message.assetName = reader.string();
                    break;
                case /* string asset_title */ 3:
                    message.assetTitle = reader.string();
                    break;
                case /* uint32 decimal */ 4:
                    message.decimal = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Asset, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 asset_id = 1; */
        if (message.assetId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.assetId);
        /* string asset_name = 2; */
        if (message.assetName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.assetName);
        /* string asset_title = 3; */
        if (message.assetTitle !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.assetTitle);
        /* uint32 decimal = 4; */
        if (message.decimal !== 0)
            writer.tag(4, WireType.Varint).uint32(message.decimal);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Asset
 */
export const Asset = new Asset$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Asset_Id$Type extends MessageType<Asset_Id> {
    constructor() {
        super("mlmbox.types.Asset.Id", [
            { no: 1, name: "asset_id", kind: "scalar", oneof: "uniqueField", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "asset_name", kind: "scalar", oneof: "uniqueField", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Asset_Id>): Asset_Id {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.uniqueField = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<Asset_Id>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Asset_Id): Asset_Id {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 asset_id */ 1:
                    message.uniqueField = {
                        oneofKind: "assetId",
                        assetId: reader.uint32()
                    };
                    break;
                case /* string asset_name */ 2:
                    message.uniqueField = {
                        oneofKind: "assetName",
                        assetName: reader.string()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Asset_Id, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 asset_id = 1; */
        if (message.uniqueField.oneofKind === "assetId")
            writer.tag(1, WireType.Varint).uint32(message.uniqueField.assetId);
        /* string asset_name = 2; */
        if (message.uniqueField.oneofKind === "assetName")
            writer.tag(2, WireType.LengthDelimited).string(message.uniqueField.assetName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Asset.Id
 */
export const Asset_Id = new Asset_Id$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Asset_Amount$Type extends MessageType<Asset_Amount> {
    constructor() {
        super("mlmbox.types.Asset.Amount", [
            { no: 1, name: "asset_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Asset_Amount>): Asset_Amount {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.assetId = 0;
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial<Asset_Amount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Asset_Amount): Asset_Amount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 asset_id */ 1:
                    message.assetId = reader.uint32();
                    break;
                case /* string value */ 2:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Asset_Amount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 asset_id = 1; */
        if (message.assetId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.assetId);
        /* string value = 2; */
        if (message.value !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Asset.Amount
 */
export const Asset_Amount = new Asset_Amount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Asset_MarketCap$Type extends MessageType<Asset_MarketCap> {
    constructor() {
        super("mlmbox.types.Asset.MarketCap", [
            { no: 1, name: "asset_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "asset_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "market_cap", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "modified_at", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Asset_MarketCap>): Asset_MarketCap {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.assetId = 0;
        message.assetName = "";
        message.marketCap = "";
        message.modifiedAt = 0;
        if (value !== undefined)
            reflectionMergePartial<Asset_MarketCap>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Asset_MarketCap): Asset_MarketCap {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 asset_id */ 1:
                    message.assetId = reader.uint32();
                    break;
                case /* string asset_name */ 2:
                    message.assetName = reader.string();
                    break;
                case /* string market_cap */ 3:
                    message.marketCap = reader.string();
                    break;
                case /* uint32 modified_at */ 4:
                    message.modifiedAt = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Asset_MarketCap, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 asset_id = 1; */
        if (message.assetId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.assetId);
        /* string asset_name = 2; */
        if (message.assetName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.assetName);
        /* string market_cap = 3; */
        if (message.marketCap !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.marketCap);
        /* uint32 modified_at = 4; */
        if (message.modifiedAt !== 0)
            writer.tag(4, WireType.Varint).uint32(message.modifiedAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Asset.MarketCap
 */
export const Asset_MarketCap = new Asset_MarketCap$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Asset_MarketCap_List$Type extends MessageType<Asset_MarketCap_List> {
    constructor() {
        super("mlmbox.types.Asset.MarketCap.List", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Asset_MarketCap }
        ]);
    }
    create(value?: PartialMessage<Asset_MarketCap_List>): Asset_MarketCap_List {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<Asset_MarketCap_List>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Asset_MarketCap_List): Asset_MarketCap_List {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.Asset.MarketCap items */ 1:
                    message.items.push(Asset_MarketCap.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Asset_MarketCap_List, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.Asset.MarketCap items = 1; */
        for (let i = 0; i < message.items.length; i++)
            Asset_MarketCap.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Asset.MarketCap.List
 */
export const Asset_MarketCap_List = new Asset_MarketCap_List$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssetList$Type extends MessageType<AssetList> {
    constructor() {
        super("mlmbox.types.AssetList", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Asset }
        ]);
    }
    create(value?: PartialMessage<AssetList>): AssetList {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<AssetList>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AssetList): AssetList {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.Asset items */ 1:
                    message.items.push(Asset.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AssetList, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.Asset items = 1; */
        for (let i = 0; i < message.items.length; i++)
            Asset.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.AssetList
 */
export const AssetList = new AssetList$Type();
